import {Component, input, model, output, signal, ChangeDetectionStrategy} from "@angular/core"
import {Vec3} from "@cm/material-nodes"
import {ScalarInputSocketComponent} from "@material-editor/components/sockets/scalar-input-socket/scalar-input-socket.component"
import {ScalarSocketRange} from "@socket-editor/types"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-vector-input-socket",
    templateUrl: "./vector-input-socket.component.html",
    styleUrls: ["./vector-input-socket.component.scss"],
    imports: [ScalarInputSocketComponent],
})
export class VectorInputSocketComponent {
    readonly $label = input<string>(undefined, {alias: "label"})
    readonly $value = model<Vec3 | undefined>(undefined, {alias: "value"})

    updateValue(index: keyof Vec3, newValue: number) {
        const value = this.$value() || {x: 0, y: 0, z: 0}
        value[index] = newValue
        this.$value.set(value)
        this.valueChange.emit(value)
    }

    readonly $connected = input(false, {alias: "connected"})

    readonly valueChange = output<Vec3>()

    readonly $range = signal<ScalarSocketRange>(null)
}
